"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_JSON_SCHEMA_PROPS = void 0;
const tslib_1 = require("tslib");
const fluent_json_schema_1 = tslib_1.__importDefault(require("fluent-json-schema"));
const defaultKeyProp = fluent_json_schema_1.default.string().required().maxLength(128);
const defaultTagValue = fluent_json_schema_1.default.string().required().maxLength(256);
exports.AWS_JSON_SCHEMA_PROPS = {
    defaultKeyProp,
    defaultTagValue,
};
//# sourceMappingURL=AwsProps.js.map